import { HistoryTable } from '@elotech/components';
import React, { FC } from 'react';

export const AuditFilterTable: FC = ({ children }) => {
  return <HistoryTable>{children}</HistoryTable>;
};
